// import { useContext } from 'react';
import { useContext } from 'use-context-selector';
import { WishlistContext } from 'Contexts/WishlistContext';

export default function useWishlists() {
  return useContext(WishlistContext);
}
